import {useFetchOneEntry} from 'hec/hooks/useFetchOneEntry'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const useFetchBuilderReference = ({
    model,
    shouldQuery,
    shouldEnrich = false,
    referenceId,
    fields = undefined
}) => {
    const config = getConfig()

    // Add defensive check for model parameter
    const isValidModel = model && typeof model === 'string' && model.trim() !== ''
    const shouldActuallyQuery = shouldQuery && isValidModel && referenceId

    // Log warning if model is invalid but query was requested
    if (shouldQuery && !isValidModel) {
        console.warn('useFetchBuilderReference: Invalid model parameter', {
            model,
            shouldQuery,
            referenceId,
            modelType: typeof model
        })
    }

    const fetchResult = useFetchOneEntry({
        queryKey: [`${model || 'unknown'}-reference`, referenceId],
        options: {
            model: model,
            // this returns reference data on entry fetches. E.g your reference has a field that is another reference. this prevents n+1 queries
            enrich: shouldEnrich || false,
            apiKey: config.app.builder.api,
            query: {
                id: referenceId
            },
            fields: fields
        },
        enabled: shouldActuallyQuery
    })

    return fetchResult
}
